module.exports = __webpack_public_path__ + "static/landwirtschafts-51dae6d15e60dde3ef3f4cca64b2876b.PNG";